export default "__VITE_ASSET__BAbiNnXu__"